import { ReactNode } from "react";

import { Media, Text } from "@/components/elements";
import { Icon } from "@/components/elements/Icon";
import { Icons } from "@/components/elements/Icon/types";

import styles from "./styles.module.css";

export type SlideProps = {
  header: string;
  icon: Icons;
  image: string;
  copy: string;
  cta?: ReactNode;
};

export const Slide = ({ copy, header, icon, image, cta }) => (
  <div className={styles.slide}>
    <Text size="m" className={styles.slide_title}>
      <span className={styles.slide_icon}>
        <Icon type={icon} />
      </span>
      {header}
    </Text>
    <Text className={styles.slide_content}>
      {copy}
      {cta && (
        <>
          <br />
          <br />
          {cta}
        </>
      )}
    </Text>
    <Media
      src={image}
      alt={header}
      className={styles.slide_image}
      aspectRatio="landscape"
      objectFit="cover"
      sizes={"(max-width: 800px) 100vw, (max-width: 992px) 50vw, 33vw"}
    />
  </div>
);
